import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { DynamicModule, InputsType } from 'ng-dynamic-component';

import { SectionBgClass } from '@valk-nx/core/lib/pipes/section-class/section-class.pipe';
import { BackgroundColors } from '@valk-nx/core/lib/pipes/section-class/section-class.types';
import { ColumnsComponent } from '@valk-nx/storyblok/components/columns/src/lib/columns';
import { HeadingGroupSectionComponent } from '@valk-nx/storyblok/components/heading-group-section/src/lib/heading-group-section';
import { RunningHeadComponent } from '@valk-nx/storyblok/components/running-head/src/lib/running-head';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { ISbStoryBlok } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

const Components = {
	columnOne: ColumnsComponent,
	columnThree: ColumnsComponent,
	columnTwo: ColumnsComponent,
	headingGroupSection: HeadingGroupSectionComponent,
	runningHead: RunningHeadComponent,
};

@Component({
	selector: 'sb-section',
	templateUrl: './section.html',
	imports: [CommonModule, DynamicModule, StoryblokDirective, SectionBgClass],
})
export class SectionComponent extends StoryblokRootDirective {
	sectionHeading = input<ISbStoryBlok[]>();
	columns = input.required<ISbStoryBlok[]>();
	sectionColor = input<BackgroundColors>('white');

	components: typeof Components = Components;

	titleInput = computed((): (InputsType & { component: string })[] => {
		const heading = this.sectionHeading();
		if (typeof heading !== 'string') {
			return (
				heading?.map((blok) => ({
					...blok,
					component: blok['component'] ?? '',
				})) || []
			);
		}
		return [];
	});

	columnsInput = computed((): (InputsType & { component: string })[] => {
		return this.columns().map((blok) => ({
			...blok,
			component: blok['component'] ?? '',
			colOne: blok['colOne'] ?? undefined,
			colTwo: blok['colTwo'] ?? undefined,
			colThree: blok['colThree'] ?? undefined,
		}));
	});

	constructor() {
		super();
	}
}
